module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/registry_desktop-cd368a262d76b198049fe86773e0bf45.png";